/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalNotesUpsertRequestDto
 */
export interface AdditionalNotesUpsertRequestDto {
    /**
     * Identity of the Additional Notes
     * @type {string}
     * @memberof AdditionalNotesUpsertRequestDto
     */
    id?: string;
    /**
     * Is there anything else important for us to know?
     * @type {string}
     * @memberof AdditionalNotesUpsertRequestDto
     */
    additionalImportantInformation?: string;
    /**
     * Are you comfortable with injectables?
     * @type {boolean}
     * @memberof AdditionalNotesUpsertRequestDto
     */
    comfortableWithInjectables: boolean;
    /**
     * Expected monthly budget
     * @type {string}
     * @memberof AdditionalNotesUpsertRequestDto
     */
    expectedMonthlyBudget: string;
    /**
     * Therapies tried previously
     * @type {string}
     * @memberof AdditionalNotesUpsertRequestDto
     */
    therapiesTriedPreviously?: string;
    /**
     * Indicates if this update is part of onboarding flow
     * @type {boolean}
     * @memberof AdditionalNotesUpsertRequestDto
     */
    isOnboarding?: boolean;
}

/**
 * Check if a given object implements the AdditionalNotesUpsertRequestDto interface.
 */
export function instanceOfAdditionalNotesUpsertRequestDto(value: object): value is AdditionalNotesUpsertRequestDto {
    if (!('comfortableWithInjectables' in value) || value['comfortableWithInjectables'] === undefined) return false;
    if (!('expectedMonthlyBudget' in value) || value['expectedMonthlyBudget'] === undefined) return false;
    return true;
}

export function AdditionalNotesUpsertRequestDtoFromJSON(json: any): AdditionalNotesUpsertRequestDto {
    return AdditionalNotesUpsertRequestDtoFromJSONTyped(json, false);
}

export function AdditionalNotesUpsertRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalNotesUpsertRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'additionalImportantInformation': json['additionalImportantInformation'] == null ? undefined : json['additionalImportantInformation'],
        'comfortableWithInjectables': json['comfortableWithInjectables'],
        'expectedMonthlyBudget': json['expectedMonthlyBudget'],
        'therapiesTriedPreviously': json['therapiesTriedPreviously'] == null ? undefined : json['therapiesTriedPreviously'],
        'isOnboarding': json['isOnboarding'] == null ? undefined : json['isOnboarding'],
    };
}

export function AdditionalNotesUpsertRequestDtoToJSON(json: any): AdditionalNotesUpsertRequestDto {
    return AdditionalNotesUpsertRequestDtoToJSONTyped(json, false);
}

export function AdditionalNotesUpsertRequestDtoToJSONTyped(value?: AdditionalNotesUpsertRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'additionalImportantInformation': value['additionalImportantInformation'],
        'comfortableWithInjectables': value['comfortableWithInjectables'],
        'expectedMonthlyBudget': value['expectedMonthlyBudget'],
        'therapiesTriedPreviously': value['therapiesTriedPreviously'],
        'isOnboarding': value['isOnboarding'],
    };
}

